import { render } from "./CommercialCompliance.vue?vue&type=template&id=7349eaec&scoped=true"
import script from "./CommercialCompliance.vue?vue&type=script&lang=js"
export * from "./CommercialCompliance.vue?vue&type=script&lang=js"

import "./CommercialCompliance.vue?vue&type=style&index=0&id=7349eaec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7349eaec"]])

export default __exports__